export const getMobileAppVersion = async (): Promise<string> => '';
